<template>
  <div
    v-if="isVisible"
    ref="modalOverlay"
    class="modal-overlay"
  >
    <div
      ref="modalContent"
      class="modal-content"
      :style="{ left: position.left + 'px', top: position.top + 'px' }"
    >
      <div
        class="drag-header"
        @mousedown="onMouseDown"
        @touchstart="onTouchStart"
      >
        <div
          class="popup-chat"
          @click="openChatWindow"
        >
          <v-icon style="color:#fff">
            mdi-open-in-new
          </v-icon>
        </div>
      </div>
      <div class="modal-header">
        <div class="tab-header">
          <v-tabs
            backgroundColor="#26384b"
            color="white"
            centered
            height="30px"
            style="margin-bottom: 10px"
            class="tab no-underline-tabs"
          >
            <v-tabs-slider />
            <v-tab
              :class="{ 'active-tab': isActiveTab(0), 'text-none': true }"
              @click="setActiveTab(0)"
            >
              <div
                style="
                  color: white;
                  font-size: 10px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <img
                  src="@/assets/images/chat_bubble_white.svg"
                  alt="Circle Image"
                  class="circle-button-image"
                >
                <div>Aquassist GPT</div>
              </div>
            </v-tab>
            <!-- activate this code for customer support chat -->
            <v-tab
              disabled
              :class="{ 'active-tab': isActiveTab(1), 'text-none': true }"
              @click="setActiveTab(1)"
            >
              <div
                style="
                  color: white;
                  font-size: 10px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <v-icon
                  color="white"
                  class="pr-3"
                >
                  mdi-chat
                </v-icon>
                <div>Chat</div>
              </div>
            </v-tab>
          </v-tabs>
        </div>
        <div class="header-text">
          {{ $t("gpt.question") }}
        </div>
      </div>
      <div class="modal-body">
        <slot name="chatSlot" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            chatWindow: null,
            isDragging: false,
            dragOffsetX: 0,
            dragOffsetY: 0,
            position: {
                left: 0,
                top: 0,
            },
            activeTab: 0,
        };
    },
    watch: {
        isVisible(value) {
            if (!value) {
                this.position = {
                    left: 0,
                    top: 0,
                };
                this.dragOffsetX = 0;
                this.dragOffsetY = 0;
            }
        },
    },
    methods: {
        onMouseDown(event) {
            if (event.target.classList.contains('drag-header')) {
                this.isDragging = true;
                this.dragOffsetX = event.clientX - this.$refs.modalContent.offsetLeft;
                this.dragOffsetY = event.clientY - this.$refs.modalContent.offsetTop;
                document.addEventListener('mousemove', this.onMouseMove);
                document.addEventListener('mouseup', this.onMouseUp);
            }
        },
        onMouseMove(event) {
            if (this.isDragging) {
                const x = event.clientX - this.dragOffsetX;
                const y = event.clientY - this.dragOffsetY;
                this.position.left = x;
                this.position.top = y;
            }
        },
        onMouseUp() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
        },
        onTouchStart(event) {
            if (event.target.classList.contains('drag-header')) {
                this.isDragging = true;
                const touch = event.touches[0];
                this.dragOffsetX = touch.clientX - this.$refs.modalContent.offsetLeft;
                this.dragOffsetY = touch.clientY - this.$refs.modalContent.offsetTop;
                document.addEventListener('touchmove', this.onTouchMove);
                document.addEventListener('touchend', this.onTouchEnd);
            }
        },
        onTouchMove(event) {
            if (this.isDragging) {
                const touch = event.touches[0];
                const x = touch.clientX - this.dragOffsetX;
                const y = touch.clientY - this.dragOffsetY;
                this.position.left = x;
                this.position.top = y;
            }
        },
        onTouchEnd() {
            this.isDragging = false;
            document.removeEventListener('touchmove', this.onTouchMove);
            document.removeEventListener('touchend', this.onTouchEnd);
        },
        setActiveTab(index) {
            this.activeTab = index;
        },
        isActiveTab(index) {
            return this.activeTab === index;
        },
        openChatWindow() {
            this.$emit('open-modal-pupUp');
            this.chatWindow = window.open(`/gpt-chat?chatWindow=${encodeURIComponent(true)}`, 'ChatWindow', 'width=600,height=600');
            const checkWindowClosed = setInterval(() => {
                if (this.chatWindow.closed) {
                    clearInterval(checkWindowClosed);
                    this.chatClosed();
                }
            }, 500);
        },
        chatClosed() {
            this.$emit('close-modal-pupUp');
        },
    },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  bottom: 120px;
  right: -30px;
  width: 40%;
  height: 80%;
  z-index: 1000;
}
@media (max-width: 1000px) {
  .modal-overlay {
    top: 20px;
    right: 0;
    width: 100%;
  }
}

.modal-content {
  position: absolute;
  width: 92%;
  background-color: white;
  pointer-events: auto;
  border-radius: 10px;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  background-color: #26384b;
  padding: 0 4px 10px 3px;
  height: 80px;
  width: 100%;
}
.drag-header {
  display: flex;
  justify-content: right;
  cursor: move;
  background-color: #26384b;
  height: 20px;
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.circle-button-image {
  width: 25px;
  height: 25px;
  object-fit:contain;
  margin-right: 5px;
}

.modal-body {
  padding-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.589);
  border-top: none;
  border-radius: 0 0 10px 10px;
  background-color: white;
}

.modal-overlay {
  pointer-events: none;
}
.active-tab {
  padding:12px 10px 12px 10px;
  border: 2px solid white;
  color: white !important;
  border-radius: 10px;
}
.v-tabs-slider {
  background-color: transparent;
}
.header-text {
  display: flex;
  justify-content: center;
  align-content: center;
  color: white;
  font-size: 12px;
  flex-direction: row;
}
.circle {
  margin-top: 3px;
  margin-right: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00ff37;
}
.popup-chat{
  margin-right:10px;
  margin-top: 2px;
}
</style>
